module.exports = __webpack_public_path__ + "static/media/Jurgen_500px.0176fa27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jurgen_500px.png
// module id = 258
// module chunks = 0